module.exports = __webpack_public_path__ + "img/214-56f535.png";